import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  canonical,
  ogType = 'website',
  ogImage = 'https://slotfleet.com/og-image.png',
  noindex = false,
  schema
}) => {
  const siteName = 'SlotFleet';
  const fullTitle = title ? title + ' | ' + siteName : siteName + ' | #1 Skill Games Management Software';
  const desc = description || 'The leading skill games management platform. Automate accounting periods, partner settlements, invoicing, inventory tracking, route planning, and multi-company location portal management.';
  const url = canonical || 'https://slotfleet.com';

  return (
    <Helmet
      title={fullTitle}
      meta={[
        { name: 'description', content: desc },
        ...(noindex ? [{ name: 'robots', content: 'noindex, nofollow' }] : []),
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: desc },
        { property: 'og:type', content: ogType },
        { property: 'og:url', content: url },
        { property: 'og:image', content: ogImage },
        { property: 'og:site_name', content: siteName },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: desc },
        { name: 'twitter:image', content: ogImage },
      ]}
      link={[{ rel: 'canonical', href: url }]}
    >
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
